/* ============================================================
   Liore Atelier — Product Pages (overview + detail)
   Vanilla JS, no dependencies. Safe to load once per page.
   ============================================================ */
(function () {
  'use strict';
  if (window.__lioreProductPages) return;
  window.__lioreProductPages = true;

  var FAV_KEY = 'liore-favs';

  /* ---- Favourites (local only) -------------------------- */
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function setFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function favIdFor(btn) {
    var holder = btn.closest('[data-fav-id]') || btn;
    return holder.getAttribute('data-fav-id');
  }
  function markFavs() {
    var favs = getFavs();
    document.querySelectorAll('[data-fav-toggle]').forEach(function (btn) {
      var id = favIdFor(btn);
      btn.classList.toggle('is-faved', id && favs.indexOf(id) !== -1);
    });
  }

  /* ---- Mobile filter sheet ------------------------------ */
  function setSheet(open) {
    var sheet = document.querySelector('[data-liore-sheet]');
    var scrim = document.querySelector('[data-liore-sheet-scrim]');
    if (!sheet) return;
    sheet.classList.toggle('is-open', open);
    sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (scrim) scrim.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  /* ---- Accordion ---------------------------------------- */
  function toggleAccordion(head) {
    var item = head.closest('.acc__item');
    if (!item) return;
    var body = item.querySelector('.acc__body');
    var isOpen = item.classList.contains('is-open');
    var group = head.closest('[data-liore-accordion]');
    if (group) {
      group.querySelectorAll('.acc__item.is-open').forEach(function (other) {
        if (other === item) return;
        other.classList.remove('is-open');
        var b = other.querySelector('.acc__body');
        if (b) b.style.maxHeight = '0px';
        var h = other.querySelector('.acc__head');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
    }
    item.classList.toggle('is-open', !isOpen);
    head.setAttribute('aria-expanded', String(!isOpen));
    if (body) body.style.maxHeight = isOpen ? '0px' : body.scrollHeight + 'px';
  }

  /* ---- Quantity stepper --------------------------------- */
  function stepQty(btn) {
    var box = btn.closest('[data-liore-qty]');
    if (!box) return;
    var input = box.querySelector('[data-liore-qty-input]');
    var output = box.querySelector('[data-liore-qty-output]');
    var step = parseInt(btn.getAttribute('data-liore-qty-step'), 10) || 0;
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = val;
    if (output) output.textContent = val;
    box.querySelectorAll('[data-liore-qty-step="-1"]').forEach(function (b) { b.disabled = val <= 1; });
  }

  /* ---- Click delegation --------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var favBtn = t.closest('[data-fav-toggle]');
    if (favBtn) {
      e.preventDefault();
      e.stopPropagation();
      var id = favIdFor(favBtn);
      if (id) {
        var favs = getFavs();
        var i = favs.indexOf(id);
        if (i === -1) favs.push(id); else favs.splice(i, 1);
        setFavs(favs);
        markFavs();
      }
      return;
    }

    if (t.closest('[data-liore-sheet-open]')) { e.preventDefault(); setSheet(true); return; }
    if (t.closest('[data-liore-sheet-close]') || t.closest('[data-liore-sheet-scrim]')) { e.preventDefault(); setSheet(false); return; }

    var accHead = t.closest('.acc__head');
    if (accHead && accHead.closest('[data-liore-accordion]')) { toggleAccordion(accHead); return; }

    var qtyBtn = t.closest('[data-liore-qty-step]');
    if (qtyBtn) { stepQty(qtyBtn); return; }

    var stickyAdd = t.closest('[data-liore-sticky-add]');
    if (stickyAdd) {
      e.preventDefault();
      var atc = document.getElementById('liore-atc');
      if (atc) atc.click();
      return;
    }

    /* gallery nav */
    var prev = t.closest('[data-liore-gal-prev]');
    var next = t.closest('[data-liore-gal-next]');
    if (prev || next) {
      var gal = t.closest('[data-liore-gallery]');
      if (gal) galStep(gal, next ? 1 : -1);
      return;
    }
    var dot = t.closest('[data-liore-gal-dot]');
    var thumb = t.closest('[data-liore-gal-thumb]');
    if (dot || thumb) {
      var galEl = t.closest('[data-liore-gallery]');
      var idx = parseInt((dot || thumb).getAttribute('data-index'), 10) || 0;
      if (galEl) galSet(galEl, idx);
      return;
    }
  });

  /* sort auto-submit */
  document.addEventListener('change', function (e) {
    var sortForm = e.target.closest('[data-liore-sort]');
    if (sortForm && e.target.matches('select')) sortForm.submit();
  });

  /* ---- Gallery ------------------------------------------ */
  function galSrcs(gal) {
    return Array.prototype.map.call(
      gal.querySelectorAll('[data-liore-gal-thumb]'),
      function (th) { return th.getAttribute('data-full'); }
    );
  }
  function galSet(gal, idx) {
    var main = gal.querySelector('[data-liore-gal-main]');
    var srcs = galSrcs(gal);
    if (!main || !srcs.length) return;
    idx = (idx + srcs.length) % srcs.length;
    main.src = srcs[idx];
    gal.setAttribute('data-current', idx);
    gal.querySelectorAll('[data-liore-gal-dot]').forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    gal.querySelectorAll('[data-liore-gal-thumb]').forEach(function (th, i) { th.classList.toggle('is-active', i === idx); });
  }
  function galStep(gal, dir) {
    var cur = parseInt(gal.getAttribute('data-current'), 10) || 0;
    galSet(gal, cur + dir);
  }

  /* ---- Sticky mobile buy bar ---------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-liore-sticky]');
    var anchor = document.querySelector('[data-liore-product] .buyrow');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var past = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-show', past);
    }, { threshold: 0 });
    obs.observe(anchor);
  }

  function init() {
    markFavs();
    initSticky();
    /* initialise open accordion heights */
    document.querySelectorAll('[data-liore-accordion] .acc__item.is-open .acc__body').forEach(function (b) {
      b.style.maxHeight = b.scrollHeight + 'px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
